module.exports = __webpack_public_path__ + "static/media/down.57d79c24.svg";